export default import.meta.ROLLDOWN_FILE_URL_xioVoT0dzCNlR661xM0qpw